/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./digitalTwinOverview.vue?vue&type=template&id=177dd822&scoped=true"
import script from "./digitalTwinOverview.vue?vue&type=script&lang=js"
export * from "./digitalTwinOverview.vue?vue&type=script&lang=js"
import style0 from "./digitalTwinOverview.vue?vue&type=style&index=0&id=177dd822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177dd822",
  null
  
)

export default component.exports